import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as d, normalizeClass as o, createElementVNode as l } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconCornerLeftDown",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function f(e, t, i, _, u, a) {
  return n(), d("svg", {
    "aria-label": i.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--corner-left-down"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Corner Left Down",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    l("path", {
      d: "M4.732 2.232A2.5 2.5 0 0 1 6.5 1.5H10a.5.5 0 0 1 0 1H6.5A1.5 1.5 0 0 0 5 4v4.793l1.646-1.647a.5.5 0 1 1 .708.708l-2.5 2.5a.5.5 0 0 1-.708 0l-2.5-2.5a.5.5 0 1 1 .708-.708L4 8.793V4a2.5 2.5 0 0 1 .732-1.768Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const b = /* @__PURE__ */ s(c, [["render", f]]);
export {
  b as default
};
//# sourceMappingURL=corner-left-down.js.map
